import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

export default function () {
	const history = useHistory()

	useEffect(() => {
		const user = sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_USER)
		
		if(user) {
			history.push('/auth/codigo_etica')
		} else {
			history.push('/codigo_etica')
		}
	}, [])

	return null
}
